import React from 'react'
import MenuData from '@data/components/submenu/adviceAndIdeas'

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faPinterest, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { getAsset, getCountry } from '@helper/getConfigValues'
import scss from './AdviceAndIdeas.module.scss'

const AdviceAndIdeas = () => {
    const countryCode = getCountry();
    const isUK = (countryCode === 'uk');
    return (
        <div className={`${scss.container} ${isUK ? scss.containerNoBanner : ''}`}>
            <div className={scss.primary}>
                <div>
                    <div className={scss.subTitle}>Wedding Guide</div>
                    <div className={scss.linksContainer}>
                        {MenuData.wedding_guide.map(({ title, url }, idx) => (
                            <a key={idx} href={url}>{title}</a>
                        ))}
                    </div>
                </div>

                <div className={scss.realWeddings}>
                    <div className={scss.subTitle}>Real Weddings</div>
                    <div className={`${scss.colWidth} ${scss.linksContainer}`}>
                        {MenuData.real_weddings.map(({ title, url }, idx) => (
                            <a key={idx} href={url}>{title}</a>
                        ))}
                    </div>
                </div>
            </div>
            <div className={scss.secondary}>
                <div className={scss.secondaryItem}>
                    {MenuData.resources.map(({ title, items }, idx) => {
                        const submenu = items.filter(i => (!i.country || countryCode == i.country));

                        if (!submenu || submenu.length === 0) {
                            return null;
                        }

                        return (
                            <div key={idx} className={idx == 0 ? (isUK ? scss.resourcesFirstLinkSectionMinContent : scss.resourcesFirstLinkSection) : ''}>
                                <div className={scss.title}>{title}</div>
                                <div className={`${scss.colWidth} ${scss.linksContainer}`}>
                                    {submenu.map(({ title, url }, idx) => (
                                        <a key={idx} href={url}>{title}</a>
                                    ))}
                                </div>
                            </div>
                        )
                    })}
                    <div>
                        <div className={scss.title}>Join the Community</div>
                        <div className={`${scss.colWidth} ${scss.linksContainer} ${scss.socialLinks}`}>
                            <a href="https://www.facebook.com/EasyWeddings/" target="_blank" rel="noopener" aria-valuetext="Easy Weddings Facebook" aria-label="Easy Weddings Facebook">
                                <span className={scss.socialLinksIconContainer}>
                                    <Icon icon={faFacebookF} className={scss.socialLinkIcon} size="sm"  />
                                </span>
                                Facebook
                            </a>
                            <a href="https://www.tiktok.com/@easyweddings/" target="_blank" rel="noopener" aria-valuetext="Easy Weddings TikTok" aria-label="Easy Weddings TikTok">
                                <span className={scss.socialLinksIconContainer}>
                                    <Icon icon={faTiktok} className={scss.socialLinkIcon} size="sm" />
                                </span>
                                TikTok
                            </a>
                            <a href="https://www.instagram.com/easyweddings/" target="_blank" rel="noopener" aria-valuetext="Easy Weddings Instagram" aria-label="Easy Weddings Instagram">
                                <span className={scss.socialLinksIconContainer}>
                                    <Icon icon={faInstagram} className={scss.socialLinkIcon} size="sm" />
                                </span>
                                Instagram
                            </a>
                            <a href="https://www.pinterest.com.au/easyweddings/" target="_blank" rel="noopener" aria-valuetext="Easy Weddings Pinterest" aria-label="Easy Weddings Pinterest">
                                <span className={scss.socialLinksIconContainer}>
                                    <Icon icon={faPinterest} className={scss.socialLinkIcon} size="sm" />
                                </span>
                                Pinterest
                            </a>
                            <a href="https://www.youtube.com/user/easyweddings/" target="_blank" rel="noopener" aria-valuetext="Easy Weddings Youtube" aria-label="Easy Weddings Youtube">
                                <span className={scss.socialLinksIconContainer}>
                                    <Icon icon={faYoutube} className={scss.socialLinkIcon} size="sm" />
                                </span>
                                Youtube
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {!isUK && <div className={scss.promo}>
                <div className={scss.bgImage} style={{ backgroundImage: `url('${getAsset("backgrounds/easy-weddings-competition_hero.jpg")}')`, backgroundSize: "cover" }}></div>
                <div className={scss.imageShadow} style={{ background: 'linear-gradient(82.83deg, #1C1C27 19.09%, rgba(28, 28, 39, 0) 70.3%)' }}></div>
                <div className={`${scss.promoInfo} p-0`}>
                    <h1 className={scss.giveawayTitle}>Wedding Cash Giveaway</h1>
                    <p className={scss.giveawayText}><a href="/competition/">Enter here</a> for a chance to win a <strong>$2,500 boost</strong> to your wedding budget</p>
                </div>
            </div>}
        </div>
    )
}

export default AdviceAndIdeas
